import { mapGetters } from 'vuex';
import popCityData from '@/common/store/glb/data.popcity';
import popCountyData from '@/common/store/glb/data.popcounty';
import geoMapper from '../../../common/store/mapper/_geoMapper.js';

const popState = ['AZ', 'CA', 'CO', 'DC', 'FL', 'GA', 'IL', 'LA', 'MA', 'MI', 'MO', 'NJ', 'NY', 'NC', 'OH', 'PA', 'TN', 'TX', 'VA', 'WA'];

export default {
    name: 'agentRegion',
    inject: ['$eventBus'],
    props: {
        showState: {
            type: Boolean,
            default: false
        },
        showCounty: {
            type: Boolean,
            default: true
        },
        cities: {
            type: Array,
            default: function(){
                return [];
            }
        },
        counties: {
            type: Array,
            default: function(){
                return [];
            }
        }
    },
    data(){
      return{
        max: 24,
        moreCity: false,
        moreCounty: false,
        moreState: false
      };
    },
    methods: {
      toggleCity(){
        this.moreCity = !this.moreCity;
      },
      toggleCounty(){
        this.moreCounty = !this.moreCounty;
      },
      toggleState(state){
        this.moreState = !this.moreState;
      }
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getStateData']),
        moreCityData(){
            return this.getCities.length > this.max;
        },
        moreCountyData(){
            return this.getCounties.length > this.max;
        },
        moureStateData(){
            return this.getStateData.length > this.max;
        },
        hasCityData(){
            if(this.cities && this.cities.length > 0){
                return true;
            }
        },
        hasCountyData(){
            if(this.counties && this.counties.length > 0){
                return true;
            }
        },
        states(){
            return popState.map(e =>{
                return {
                    url: `${this.glb.appUrl}sitemap/agents/${e.toLocaleLowerCase()}/`,
                    text: this.getStateData[e]
                };
            });

        },
        getCities(){
            if(this.hasCityData){
                return this.cities.map(city => {
                    const geo = geoMapper(city, this.glb.rentals);
                    return {
                        url: `${this.glb.appUrl}agents/${geo.cityPath}`,
                        text: geo.city
                    };
                });
            }
            return popCityData.map(item =>{
                return {
                    url: `${this.glb.appUrl}agents/${item.cityPath}`,
                    text: item.city
                };
            });
        },
        getCounties(){
            if(this.hasCountyData){
                return this.counties.map(county => {
                    const geo = geoMapper(county, this.glb.rentals);
                    return {
                        url: `${this.glb.appUrl}sitemap/agents/${geo.countyPath}`,
                        text: geo.county
                    };
                });
            }
            return popCountyData.map(item => {
                return {
                    url: `${this.glb.appUrl}sitemap/agents/${item.countyPath}`,
                    text: item.county
                };
            });
        }
    }
};
